import React from 'react';

const Privacy = () => {
  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="bg-[#0D2847] text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold mb-4">Privacy Policy</h1>
          <p className="text-xl text-white/90">Last updated: {new Date().toLocaleDateString()}</p>
        </div>
      </section>

      {/* Privacy Content */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <h2 className="text-2xl font-bold text-[#0D2847] mb-4">Introduction</h2>
            <p className="text-gray-600 mb-6">
              At Rudra Essence, we are committed to protecting your privacy and ensuring the security of your personal information. 
              This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website 
              or use our services.
            </p>

            <h2 className="text-2xl font-bold text-[#0D2847] mb-4">Information We Collect</h2>
            <p className="text-gray-600 mb-4">We may collect the following types of information:</p>
            <ul className="list-disc pl-6 text-gray-600 mb-6">
              <li><strong>Personal Information:</strong> Name, email address, phone number, and other contact details you provide when filling out forms or contacting us.</li>
              <li><strong>Usage Data:</strong> Information about how you access and use our website, including your IP address, browser type, and pages visited.</li>
              <li><strong>Communications:</strong> Records of correspondence when you contact us or subscribe to our newsletter.</li>
            </ul>

            <h2 className="text-2xl font-bold text-[#0D2847] mb-4">How We Use Your Information</h2>
            <p className="text-gray-600 mb-4">We use the information we collect to:</p>
            <ul className="list-disc pl-6 text-gray-600 mb-6">
              <li>Respond to your inquiries and provide customer support</li>
              <li>Send you information about our products and services</li>
              <li>Improve our website and user experience</li>
              <li>Send newsletters and marketing communications (with your consent)</li>
              <li>Comply with legal obligations</li>
            </ul>

            <h2 className="text-2xl font-bold text-[#0D2847] mb-4">Data Protection</h2>
            <p className="text-gray-600 mb-6">
              We implement appropriate technical and organizational security measures to protect your personal information 
              from unauthorized access, disclosure, alteration, or destruction. However, no method of transmission over the 
              Internet is 100% secure, and we cannot guarantee absolute security.
            </p>

            <h2 className="text-2xl font-bold text-[#0D2847] mb-4">Sharing Your Information</h2>
            <p className="text-gray-600 mb-6">
              We do not sell, trade, or rent your personal information to third parties. We may share information with trusted 
              service providers who assist us in operating our website and conducting our business, provided they agree to keep 
              this information confidential.
            </p>

            <h2 className="text-2xl font-bold text-[#0D2847] mb-4">Your Rights</h2>
            <p className="text-gray-600 mb-4">You have the right to:</p>
            <ul className="list-disc pl-6 text-gray-600 mb-6">
              <li>Access the personal information we hold about you</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your personal information</li>
              <li>Object to processing of your personal information</li>
              <li>Withdraw consent for marketing communications at any time</li>
            </ul>

            <h2 className="text-2xl font-bold text-[#0D2847] mb-4">Cookies</h2>
            <p className="text-gray-600 mb-6">
              Our website may use cookies to enhance your browsing experience. Cookies are small files stored on your device 
              that help us understand how you use our site. You can choose to disable cookies through your browser settings, 
              though this may affect some website functionality.
            </p>

            <h2 className="text-2xl font-bold text-[#0D2847] mb-4">Third-Party Links</h2>
            <p className="text-gray-600 mb-6">
              Our website may contain links to third-party websites. We are not responsible for the privacy practices or content 
              of these external sites. We encourage you to review the privacy policies of any third-party sites you visit.
            </p>

            <h2 className="text-2xl font-bold text-[#0D2847] mb-4">Changes to This Policy</h2>
            <p className="text-gray-600 mb-6">
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy 
              Policy on this page and updating the "Last updated" date.
            </p>

            <h2 className="text-2xl font-bold text-[#0D2847] mb-4">Contact Us</h2>
            <p className="text-gray-600 mb-2">
              If you have any questions about this Privacy Policy or our data practices, please contact us at:
            </p>
            <p className="text-gray-600">
              <strong>Email:</strong> info@rudraessence.com<br />
              <strong>Phone:</strong> +971-56-7295491
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
